import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Injectable } from '@angular/core';
import { SsoService } from '../../sso/sso.service';

import { ElemInstalacionModel } from '../models/instalacion/elem-instalacion.model';
import { ElementoModel } from 'movisat-ia/lib/services/elements/elem.model';
import { firstValueFrom } from 'rxjs';

export enum InstallationTypes {
  TAG = 1,
  VOLUMETRIC = 2,
  LOCK = 3,
  IDENTIFIER = 4
}

const ACTION_TYPE_INSTALLATION = 1;
@Injectable({
  providedIn: 'root'
})
export class InstalacionService {
  private empresaId: number = this.ssoService.getTicket().Empresa.IdGestion;

  constructor(
    private http: HttpClient,
    private ssoService: SsoService) { }

  async getInstalacionByElement(elemId: number): Promise<ElemInstalacionModel> {
    let instalacion: ElemInstalacionModel = new ElemInstalacionModel();
    try {
      instalacion = await this.http.get<ElemInstalacionModel>(
        `${this.ssoService.getTicket().UrlApi}/api/instalacion/elemento?id=${elemId}&enterprise=${this.empresaId}&include=all`
      ).toPromise();
    } catch (error) {
    }

    return instalacion;
  }

  async saveInstalacion(instalacion: ElemInstalacionModel, elemId: number) {
    let response: ElemInstalacionModel;

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    instalacion.empresa = this.empresaId;
    instalacion.idElemento = elemId;

    try {
      response = await this.http.post<ElemInstalacionModel>(this.ssoService.getTicket().UrlApi + '/api/instalacion',
        JSON.stringify(instalacion), httpOptions).toPromise();

      if (response) {
        return response;
      } else {
        return null;
      }
    } catch (error) {
      return null;
    }
  }

  async saveInstalacionList(elementos: ElementoModel[], instalaciones: InstallationTypes[], observaciones: string = ""): Promise<any> {
    let response;
    const payload = {
      empresa: this.empresaId,
      observaciones,
      idsElementos: elementos.map(elem => (elem as any as { id: number }).id ?? elem.Id),
      instalaciones: instalaciones.map(instalacion => ({
        idTipo: instalacion,
        idAccion: ACTION_TYPE_INSTALLATION
      }))
    };

    try {
      response = await firstValueFrom(this.http.post<any>(this.ssoService.getTicket().UrlApi + '/api/instalaciones', payload));
    } catch (e) {
      console.log(e);
    }
    return response ?? null;
  }

  public async getInstalaciones(): Promise<ElemInstalacionModel[]> {
    let response: ElemInstalacionModel[] = [];
    try {
      response = await firstValueFrom(this.http.get<ElemInstalacionModel[]>(`${this.ssoService.getTicket().UrlApi}/api/elementos/instalaciones/reporte/estado-actual?enterprise=${this.empresaId}`));
    } catch (e) {
      console.log(e);
    }
    return response ?? [];
  }
}
